import { render, staticRenderFns } from "./_controlTabs.vue?vue&type=template&id=abe2ae06&scoped=true&"
import script from "./_controlTabs.vue?vue&type=script&lang=js&"
export * from "./_controlTabs.vue?vue&type=script&lang=js&"
import style0 from "./_controlTabs.vue?vue&type=style&index=0&id=abe2ae06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe2ae06",
  null
  
)

export default component.exports